import PropTypes from 'prop-types';
import { createContext, useState } from 'react';

// project import
import config from 'config';
import { useLocalStorage } from 'utils/common';
import { sessionConfig } from 'utils/constant';
import i18n from 'i18nConfig';

// initial state
const initialState = {
  ...config,
  onChangeContainer: () => {},
  onChangeLocalization: () => {},
  onChangeMode: () => {},
  onChangePresetColor: () => {},
  onChangeDirection: () => {},
  onChangeMiniDrawer: () => {},
  onChangeFontFamily: () => {}
};

// ==============================|| CONFIG CONTEXT & PROVIDER ||============================== //

const ConfigContext = createContext(initialState);

function ConfigProvider({ children }) {
  // const [config, setConfig] = useLocalStorage('mantis-react-ts-config', initialState);

  const { getStorage, setStorage } = useLocalStorage();
  const storedMode = getStorage(sessionConfig.mode);
  const [currentMode, setCurrentMode] = useState(_.isEmpty(storedMode) ? 'light' : storedMode);
  const config = getStorage(sessionConfig.mantisConfig);
  const setConfig = (obj) => setStorage(sessionConfig.mantisConfig, obj);

  const onChangeContainer = () => {
    setConfig({
      ...config,
      container: !config.container
    });
  };

  const onChangeLocalization = (lang) => {
    i18n.changeLanguage(lang);
    setStorage(sessionConfig.lang, lang);
  };

  const onChangeMode = (mode) => {
    setCurrentMode(mode);
    setStorage(sessionConfig.mode, mode);

    // setConfig({
    //   ...config,
    //   mode
    // });
  };

  const onChangePresetColor = (theme) => {
    setConfig({
      ...config,
      presetColor: theme
    });
  };

  const onChangeDirection = (direction) => {
    setConfig({
      ...config,
      themeDirection: direction
    });
  };

  const onChangeMiniDrawer = (miniDrawer) => {
    setConfig({
      ...config,
      miniDrawer
    });
  };

  const onChangeFontFamily = (fontFamily) => {
    setConfig({
      ...config,
      fontFamily
    });
  };

  return (
    <ConfigContext.Provider
      value={{
        ...config,
        i18n,
        mode: currentMode,
        onChangeContainer,
        onChangeLocalization,
        onChangeMode,
        onChangePresetColor,
        onChangeDirection,
        onChangeMiniDrawer,
        onChangeFontFamily
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
}

ConfigProvider.propTypes = {
  children: PropTypes.node
};

export { ConfigProvider, ConfigContext };
